// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3FZQ8","Label":"BuildControl_Label__3tKEX","Less":"BuildControl_Less__3TbjD","More":"BuildControl_More__35n-C"};